import { MajorLeagueHackingBadge } from "../../../../src/components/MajorLeagueHackingBadge";
import { EventJumbotronParallax } from "../../../../src/components/EventJumbotronParallax";
import { SectionTypes, Section } from "../../../../src/components/Section";
import { EventFullDescription } from "../../../../src/components/EventFullDescription";
import { EventCountdownSection } from "../../../../src/components/EventCountdownSection";
import { EventLocationSection } from "../../../../src/components/EventLocationSection";
import { EventScheduleSection } from "../../../../src/components/EventScheduleSection";
import { EventPeopleSection } from "../../../../src/components/EventPeopleSection";
import { HackathonDefinitionSection } from "../../../../src/components/HackathonDefinitionSection";
import { EventFrequentlyAskedQuestionsSection } from "../../../../src/components/EventFrequentlyAskedQuestionsSection";
import { EventSponsorsSection } from "../../../../src/components/EventSponsorsSection";
import { Image as Whatever } from "../../../../src/components/Img";
import { SiteButton } from "../../../../src/components/SiteClickable";
import { ButtonsContainer } from "../../../../src/components/ButtonsContainer";
import { FaCalendarAlt, FaDiscord, FaMapMarkerAlt, FaTicketAlt } from "react-icons/fa";
import hackaway6logo from "../../../../src/assets/images/logo/rh-white-montserrat-v6.png";
import { hackaway6logoClass } from "../../../../src/posts/events/hackawayv6/v6.module.scss";
import * as React from 'react';
export default {
  MajorLeagueHackingBadge,
  EventJumbotronParallax,
  SectionTypes,
  Section,
  EventFullDescription,
  EventCountdownSection,
  EventLocationSection,
  EventScheduleSection,
  EventPeopleSection,
  HackathonDefinitionSection,
  EventFrequentlyAskedQuestionsSection,
  EventSponsorsSection,
  Whatever,
  SiteButton,
  ButtonsContainer,
  FaCalendarAlt,
  FaDiscord,
  FaMapMarkerAlt,
  FaTicketAlt,
  hackaway6logo,
  hackaway6logoClass,
  React
};